import { Box } from 'lucide-react';

const AssetPreviewCard = ({ asset }) => {
  if (!asset) return null;
  return (
    // 1. ????? ????? ?? w-96 (384px) ?????? padding ????
    <div className="bg-white border-2 border-blue-900 rounded-xl shadow-2xl p-5 w-96 z-[9999] animate-in zoom-in duration-200 uppercase font-black">
      
      {/* Header Section */}
      <div className="flex items-center gap-3 border-b pb-3 mb-3">
        <div className="bg-blue-100 p-2.5 rounded-lg">
          <Box size={22} className="text-blue-900" />
        </div>
        <div className="flex flex-col">
          <span className="text-[10px] text-gray-400 tracking-widest">Asset Detail</span>
          <span className="text-blue-900 text-[15px] leading-none">{asset.assetnum}</span>
        </div>
      </div>
      
      <div className="space-y-3">
        {/* Description Section */}
        <div className="flex flex-col">
          <span className="text-[9px] text-gray-400 mb-1">Description</span>
          <span className="text-gray-700 text-[11px] leading-snug font-bold">
            {asset.description || 'No Description Available'}
          </span>
        </div>
        
        {/* Info Grid */}
        <div className="grid grid-cols-2 gap-4 py-2 border-y border-gray-100">
          <div>
            <span className="text-[9px] text-gray-400 block mb-1">Status</span>
            <span className={`px-3 py-1 rounded text-[9px] text-white inline-block ${asset.status === 'OPERATING' ? 'bg-green-600' : 'bg-red-600'}`}>
              {asset.status}
            </span>
          </div>
          <div>
            <span className="text-[9px] text-gray-400 block mb-1">Location</span>
            <span className="text-blue-800 text-[11px] block truncate">{asset.location_id || '---'}</span>
          </div>
        </div>

        {/* 2. ????? ??????: ????? ???????? ????????? object-contain ???? ???? ????? */}
        {asset.image_url && (
          <div className="mt-3 bg-gray-50 rounded-lg border border-gray-200 overflow-hidden">
             <img 
               src={asset.image_url} 
               alt="Asset" 
               className="w-full h-48 object-contain bg-white" // h-48 ???? ????? ???? ??????
             />
          </div>
        )}
      </div>
    </div>
  );
};

export default AssetPreviewCard;